// extracted by mini-css-extract-plugin
export default {"container":"Configurations_container__+PG7i","mainContainer":"Configurations_mainContainer__5l2ZS"};